import httpAuth from "@/common/http-common";
import { 
  NotificationType, 
  AssessmentDto,
  UserNotification,
  SmsNotification
} from "@/views/sidebar/notification/notification.type";

class NotificationService {
  async getNotificationTypes(clientId: number) {
    const { data } = await httpAuth().get<NotificationType[]>(
      '/Dashboard/GetNotificationTypes', { params: { 
        clientId: clientId
      } 
    });
    return data;
  }

  async createAssessment(assessmentDto: AssessmentDto) {
    const { data } = await httpAuth().post(
      `/Assessment/invite-patient-clinic`, 
      assessmentDto 
    );
    return data;
  }

  async sendNotification(userNotification: UserNotification) {
    const { data } = await httpAuth().post(
      `/Notification/SendUserNotification`, 
      userNotification 
    );
    return data;
  }

  async sendSmsNotification(smsNotification: SmsNotification) {
    const { data } = await httpAuth().post(
      `/Dashboard/SendSmsNotification`, 
      smsNotification 
    );
    return data;
  }
}

export default new NotificationService();